const partialConversionColumnNamePairs = {
  // Old column : New column
  Conversions: 'ConversionsCredit',
  CPA: 'PartialConversionCPA',
  ConversionRate: 'PartialConversionRate',
  AllConversionCPA: 'AllPartialConversionCPA',
  AllConversions: 'AllConversionsCredit',
  AllConversionRate: 'AllPartialConversionRate',
  ViewThroughConversionsCPA: 'ViewThroughPartialConversionsCPA',
  ViewThroughConversionsRate: 'ViewThroughPartialConversionsRate',
  ViewThroughConversions: 'ViewThroughConversionsCredit',
};

export const defaultColumnConversions = {
  ...partialConversionColumnNamePairs,
};
